import { motion } from "framer-motion";
import { IMAGES } from "@/lib/images";
import { Reveal } from "./Reveal";

const VALUES = [
  { title: "Training with purpose", desc: "Every technique taught with intention and mastery in mind." },
  { title: "Growing with passion", desc: "A culture that celebrates craft, artistry, and sisterhood." },
  { title: "Creating futures", desc: "We don't just build braiders — we build careers and legacies." },
];

export const BehindTheBraid = () => (
  <section id="story" data-testid="story-section" className="bg-wine-deep py-24 sm:py-32">
    <div className="max-w-[1400px] mx-auto px-6">
      <div className="grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5">
          <Reveal>
            <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold">
              Behind the Braid
            </span>
            <h2 className="font-display font-light text-cream text-5xl sm:text-6xl leading-[1] mt-5">
              More than a school. A <span className="italic text-gold">sisterhood.</span>
            </h2>
            <p className="text-cream/60 mt-6 text-lg leading-relaxed">
              Step inside Beauti N Braid Academy — a space designed for artists to grow, create, and
              belong. Our studio is where discipline meets warmth, and where every braider finds her
              crown.
            </p>
            <div className="mt-10 space-y-6">
              {VALUES.map((v, i) => (
                <Reveal key={v.title} delay={i * 0.1}>
                  <div className="flex gap-4">
                    <span className="mt-2 h-2 w-2 rounded-full bg-gold shrink-0" />
                    <div>
                      <div className="font-display text-2xl text-cream">{v.title}</div>
                      <div className="text-cream/55">{v.desc}</div>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <div className="grid grid-cols-2 gap-4">
            <Reveal className="col-span-2">
              <div className="relative overflow-hidden rounded-3xl aspect-[16/9] group">
                <motion.img
                  src={IMAGES.gallery[0]}
                  alt="Academy studio"
                  className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
            </Reveal>
            <Reveal delay={0.1}>
              <div className="relative overflow-hidden rounded-3xl aspect-[4/5] group">
                <motion.img
                  src={IMAGES.gallery[1]}
                  alt="Studio detail"
                  className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
            </Reveal>
            <Reveal delay={0.2}>
              <div className="relative overflow-hidden rounded-3xl aspect-[4/5] group">
                <motion.img
                  src={IMAGES.gallery[2]}
                  alt="Studio detail"
                  className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </div>
  </section>
);
